<template>
  <!-- The site header, by theme (WEB_V2_BUILD.md §4 "nav" slot): today's bar
       for Glass, Flat, Night Watch and the classic themes (LegacyNavBar), the
       new header for every other theme (themes/nav/SiteHeader). Same props
       for both, so pages don't need to know which. -->
  <component :is="Impl" ref="inner" v-bind="$attrs" :company-name="companyName" :logo="logo" :nav-setup="navSetup"
             :available-pages="availablePages" :show-company-name="showCompanyName" :start-dimmed="startDimmed"
             :product-page-name="productPageName" :showcase-page-name="showcasePageName" />
</template>

<script setup>
import {ref} from "vue";
import {useThemedComponent} from "@/composables/useThemedComponent.js";

defineOptions({inheritAttrs: false});
defineProps({
  companyName: String,
  logo: {type: String, default: ""},
  navSetup: {type: String, default: "name"},
  availablePages: {type: Object, default: () => ({})},
  showCompanyName: {type: Boolean, default: true},
  startDimmed: {type: Boolean, default: false},
  productPageName: {type: String, default: "Products"},
  showcasePageName: {type: String, default: "Showcase"},
});

const Impl = useThemedComponent("nav");
const inner = ref(null);
defineExpose({barHeight: () => inner.value?.barHeight?.() ?? 80});
</script>
